import { getAppSetting } from '@/domains/core/settings/appSettings';

export const searchEngineProxyPool = (): boolean => {
  const trafficPercentage =
    Number(getAppSetting('ALGOLIA_PROXY_PERCENTAGE_TRAFFIC')) || 0;
  const coinflip = Math.random() < trafficPercentage / 100;

  return coinflip;
};
